/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ApiKeyType = 'Legacy' | 'SingleAgent' | 'WLA' | 'EndpointAgent' | 'RestApi' | 'AuthApi';

export const ApiKeyType = {
    Legacy: 'Legacy' as ApiKeyType,
    SingleAgent: 'SingleAgent' as ApiKeyType,
    Wla: 'WLA' as ApiKeyType,
    EndpointAgent: 'EndpointAgent' as ApiKeyType,
    RestApi: 'RestApi' as ApiKeyType,
    AuthApi: 'AuthApi' as ApiKeyType
};

